import React, { useState, useEffect } from "react";
import RestClient from "../../../@core/restClient";
import Spinner from "../UI/Spinner";
import "./CopySong.scss";

const CopySong = ({ closeCopySong, song }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [allBooks, setAllBooks] = useState<any>([]);
  const [noBooks, setNoBooks] = useState(false);
  const [message, setMessage] = useState("");
  const [complete, setComplete] = useState(false);

  // GET SONG BOOK LISTS
  useEffect(function () {
    (async () => {
      setIsLoading(true);
      try {
        const id = JSON.parse(localStorage.getItem("User") || "{}")?.id;
        if (!id) {
          console.log("incorrect User id");
          return;
        }
        const ownBooks = await RestClient.getSongBooks(id);
        const collBooks = await RestClient.getSongBooksCollaborators(id);
        if (ownBooks && collBooks) {
          const books = [...ownBooks, ...collBooks];
          if (books.length === 0) {
            setNoBooks(true);
          } else {
            setAllBooks(books);
            setNoBooks(false);
          }
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  // ADD SONG TO THE SONGBOOK

  const copySong = async (bookId: any) => {
    setIsLoading(true);
    try {
      const newSong = {
        categories: song.categories.map((cat: any) => cat.id),
        files: [],
        key: song.key,
        songbookId: bookId,
        tempo: song.tempo,
        text: song.text,
        time: song.time,
        title: song.title,
        subTitle: song.subTitle
      };
      const copy = await RestClient.addSong({ ...newSong, songbookId: bookId });
    } catch (error) {
      console.log("error");
      setMessage("Щось пішло не так, спробуйте ще раз.");
    }
    setIsLoading(false);
    setComplete(true);
    setMessage("Пісню успішно скопійовано!");
  };

  return (
    <div className="copy-song">
      <div className="copy-song-inner">
        {isLoading ? <Spinner /> : ""}
        <p className="copy-song-inner-intro">
          Cкопіювати пісню <span>{song.title}</span> у пісенник:
        </p>
        {!noBooks ? (
          <>
            <div className="books">
              {allBooks.map((book: any) => (
                <div
                  className="books-item"
                  key={book.id}
                  onClick={() => copySong(book.id)}
                >
                  {book.title}
                </div>
              ))}
            </div>
            <p className="media-message">
              Медія ресурси цієї пісні, якщо вони є, не будуть скопійовані в
              інший пісенник.
            </p>
          </>
        ) : (
          <div className="noBooks">У вас немає пісенників.</div>
        )}
        <button className="btn-plain copy-btn" onClick={() => closeCopySong()}>
          Скасувати
        </button>

        {complete ? (
          <div className="copy-song-inner-message">
            <p>{message}</p>
            <button className="btn-mcolor" onClick={() => closeCopySong()}>
              Ok
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default CopySong;
